import { useState, useEffect } from 'react';

export const useResizeImg = (desktopImgUrl, mobileImgUrl) => {
   const [imageSource, setImageSource] = useState(mobileImgUrl);
   useEffect(() => {
      const updateImage = () => {
         if (window.matchMedia('(min-width: 900px)').matches) {
            setImageSource(desktopImgUrl);
         } else {
            setImageSource(mobileImgUrl);
         }
      };
      window.addEventListener('resize', updateImage);
      updateImage();

      return () => {
         window.removeEventListener('resize', updateImage);
      };
   }, [desktopImgUrl, mobileImgUrl]);

   return imageSource;
};


